import React, { FunctionComponent, useState } from "react";
import { GameInfoProps } from "../../type";
import Utils from "../../utils";
import { NotFoundView } from "../not-found";
import { Setting } from "./types";
import BigNumber from "bignumber.js";

export const OlympusGlorySettingView: FunctionComponent<GameInfoProps> = ({
  data,
}) => {
  const settings = data as Setting;
  const currencies = settings.currencies;
  const [showCurrency, setShowCurrency] = useState(
    Object.values(currencies)[0]?.currency ?? ""
  );
  const currencySetting = currencies.find((s) => s.currency === showCurrency);
  if (!currencySetting) return <NotFoundView />;
  Utils.setCurrencySymbol(currencySetting.symbol);
  const minBallCount = settings.minBallCount;
  const maxBallCount = settings.maxBallCount;
  const payouts = settings.payoutMultipliers.sort((a, b) => a - b);
  const bonusPayouts = settings.bonusPayoutMultipliers.sort((a, b) => a - b);
  return (
    <>
      <ul className="nav nav-pills mb-3">
        {Object.values(currencies).map((c) => (
          <li key={c.currency} className="nav-item">
            <button
              className={`nav-link${
                c.currency === showCurrency ? " active" : ""
              }`}
              onClick={() => {
                setShowCurrency(c.currency);
              }}
            >
              {c.currency}
            </button>
          </li>
        ))}
      </ul>
      <div className="table-responsive">
        <table className="table table-bordered">
          <colgroup>
            <col width={"10%"} />
            <col width={"10%"} />
            <col width={"10%"} />
            <col width={"10%"} />
            <col width={"10%"} />
          </colgroup>
          <thead>
            <tr>
              <th className="align-middle text-center">Chip</th>
              <th className="align-middle text-center">Min Bet</th>
              <th className="align-middle text-center">Max Bet</th>
              <th className="align-middle text-center">Payout</th>
              <th className="align-middle text-center">Bonus Payout</th>
            </tr>
          </thead>
          <tbody>
          {currencySetting.chipOptions.map((c) => 
            <>
              <tr key={c}>
                <td className="align-middle text-center blue-currency" rowSpan={2}>
                  {Utils.asCurrency(c)}
                </td>
                <td className="align-middle text-center blue-currency">
                  {Utils.asCurrency(BigNumber(c).multipliedBy(minBallCount))}
                </td>
                <td className="align-middle text-center blue-currency">
                  {Utils.asCurrency(BigNumber(c).multipliedBy(maxBallCount))}
                </td>
                <td className="align-middle text-center">
                  {payouts.map((p) => 
                    <p> 1 : {p} </p>
                  )}
                </td>
                <td className="align-middle text-center">
                  {bonusPayouts.map((p) => 
                    <p> 1 : {p} </p>
                  )}
                </td>
              </tr>
              <tr>
                <th className="align-middle text-end" colSpan={2}>
                  <p className="mb-2 mt-2"> Total Max Exposure </p>
                  <p className="mb-2 mt-2"> (Best Combination) </p>
                </th>
                <td className="align-middle text-center blue-currency" colSpan={2}>
                  {Utils.asCurrency(BigNumber(c).multipliedBy(300))}
                </td>
              </tr>
            </>
          )}
          </tbody>
        </table>
      </div>
    </>
  );
};
